import * as React from "react";

import { cn } from "@/lib/utils";
import { inputGlowWrap, inputGlowInner } from "@/lib/card-styles";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & { wrapperClassName?: string }
>(({ className, type, wrapperClassName, ...props }, ref) => {
  return (
    <div className={cn(inputGlowWrap, wrapperClassName)}>
      <div className={inputGlowInner}>
        <input
          type={type}
          className={cn(
            "flex w-full bg-transparent px-3 py-1.5 text-base placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className,
          )}
          ref={ref}
          {...props}
        />
      </div>
    </div>
  );
});
Input.displayName = "Input";

export { Input };
